<template>
    <span :class="flagClass" :title="title"></span>
</template>

<script>
export default {
    name: 'FlagIconCustom',
    props: {
        iso: {
            type: String,
            required: true
        },
        squared: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        }
    },
    computed: {
        flagClass() {
            const classes = ['fi', `fi-${this.iso.toLowerCase()}`]
            if (this.squared) {
                classes.push('fis')
            }
            return classes.join(' ')
        }
    }
}
</script>
